import { render, staticRenderFns } from "./vehicleInvoiceButler.block.vue?vue&type=template&id=911486ba&"
import script from "./vehicleInvoiceButler.block.vue?vue&type=script&lang=ts&"
export * from "./vehicleInvoiceButler.block.vue?vue&type=script&lang=ts&"
import style0 from "./vehicleInvoiceButler.block.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VSkeletonLoader})
